const actions = {
  SET_STATE: 'sms/SET_STATE',
  LOAD_ALL: 'sms/LOAD_ALL',
  SEND_SMS: 'sms/SEND_SMS',
  SHOW_CREATE: 'sms/SHOW_CREATE',
  HIDE_CREATE: 'sms/HIDE_CREATE',
}

export default actions
